import { TextInput, Selectinput } from "../components/Inputs";
import { useState } from "react";
import { Button } from "../components/Button";
import { useNavigate, useParams } from "react-router-dom";
import useAxios from "../hooks/useAxios";
import { config } from "../config";

export default function BankAccount({ profile, setStep, setProfile }: any) {
    const navigate = useNavigate()
    const { id } = useParams<{ id: string }>();
    const axios = useAxios()
    const [errorMessage, setErrorMessage] = useState('');
    const [saving, setSaving] = useState(false);
    
    let t = {
        accountName: '',
        routingNumber: '',
        accountNumber: '',
        accountType: '',
        ...(profile?.bankAccount ?? {})
    }
    const [formData, setFormData] = useState(t)

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value })
    };

    const handleNext = async () => {
        try {
            setSaving(true);
            setErrorMessage('')
            const newProfile = {...profile, bankAccount: formData}
            await axios.post(`${config.backendUrl}/accounts/onboarding-forms/${id}/`, newProfile)
            setProfile(newProfile)
            navigate(`/form/${id}/success`)
        } catch (err: any) {
            console.error(err)
            setErrorMessage(err.response?.data?.message || 'An error occurred while saving the bank account information')
        } finally {
            setSaving(false);
        }
    }

    function generateAccountTypeOptions() {
        return [
            { value: '', label: 'Select account type' },
            { value: 'personal_checking', label: 'Personal Checking' },
            { value: 'personal_savings', label: 'Personal Savings' },
            { value: 'business_checking', label: 'Business Checking' },
            { value: 'business_savings', label: 'Business Savings' }
        ]
    }

    return (
        <div>
            <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                <h3 className="text-sm font-semibold text-gray-900 mb-2">Why we need your bank account information</h3>
                <p className="text-sm text-gray-700">
                    We require your bank account details to settle funds into this account.
                </p>
            </div>
            <div className="mb-4">
                <TextInput 
                    label="Account Name" 
                    name="accountName" 
                    value={formData.accountName} 
                    onChange={handleInputChange} 
                    placeholder="Account holder name"
                />
            </div>
            <div className="mb-4">
                <TextInput 
                    label="Routing Number" 
                    name="routingNumber" 
                    value={formData.routingNumber} 
                    onChange={handleInputChange} 
                    placeholder="9-digit routing number"
                />
            </div>
            <div className="mb-4">
                <TextInput 
                    label="Account Number" 
                    name="accountNumber" 
                    value={formData.accountNumber} 
                    onChange={handleInputChange} 
                    placeholder="Account number"
                />
            </div>
            <div className="mb-4">
                <Selectinput 
                    options={generateAccountTypeOptions()} 
                    name="accountType" 
                    value={formData.accountType} 
                    label="Account Type" 
                    onChange={handleInputChange} 
                />
            </div>
            <p className="text-sm text-red-500 mb-3">{errorMessage}</p>
            <div className="space-x-3">
                <Button onClick={() => setStep((prev: number) => prev - 1)}>Previous</Button>
                <Button onClick={handleNext} disabled={saving}>{saving ? 'Saving...' : 'Continue'}</Button>
            </div>
        </div>
    )
}

